import React, { Component, useState ,useEffect} from 'react';
import Axios from 'axios';
import { Link } from "react-router-dom";
import Helpers from "../Helpers/Custom";
import Config  from "../Helpers/Config";
import TabsComp from '../Shared/TabsComp';
import Tab from 'react-bootstrap/Tab';
import Table from "../Shared/Table";
import Pie from "../Shared/Pie";
import Bar from "../Shared/Bar";
import GraphsCard from "./GraphsCard";

function Equity(props,{payload}) {

    const [data, setData] = useState({});
    const [graphData, setGraphData] = useState({});
    const [loading, setLoading] = useState(false);

    const [marketValueByCurrency, setMarketValueByCurrency] = useState({});
    const [marketValueBySector, setMarketValueBySector] = useState({});
    const [top5Gainers, setTop5Gainers] = useState({});
    const [top5Losers, setTop5Losers] = useState({});

   

    useEffect(() => {
        fetchEquityDetails();
     }, [props.payload]);


     const fetchEquityDetails = ()=>{
        setLoading(true)
        Axios.get(Config.api("api/portfolio/valuation/"+props.name),{
            params:props.payload
        })
        .then( (response) => {
            setLoading(false)
            var dataset  = response.data;

            var top5GainersLcl = {};
            var top5LosersLcl = {};

            var topGainersCat = []
            var topGainersVal = []

            var topLoosersCat = []
            var topLoosersVal = []

            dataset?.extras?.top5Gainers?.forEach((list,i)=>{
                topGainersCat.push(list?.key?.name);
                topGainersVal.push(list.value);
            });
            top5GainersLcl.topGainersCat = topGainersCat;
            top5GainersLcl.topGainersVal = topGainersVal;

            dataset?.extras?.top5Losers?.forEach((list,i)=>{
                topLoosersCat.push(list?.key?.name);
                topLoosersVal.push(list.value);
            });

            // topLoosersCat.push("Test");
            // topLoosersVal.push(-160);

            top5LosersLcl.topLoosersCat = topLoosersCat;
            top5LosersLcl.topLoosersVal = topLoosersVal;
            
            // {
            //                     name:"data",
            //                     data:topLoosersVal
            // }

            setMarketValueByCurrency(dataset?.extras?.marketValueByCurrency.map(x=>({"name":x.key.name,"y": x.value})) ?? {});
            setMarketValueBySector(dataset?.extras?.marketValueBySector.map(x=>({"name":x.key.name,"y": x.value})) ?? {})
            // setMarketValueBySector()
            setTop5Gainers(top5GainersLcl)
            setTop5Losers(top5LosersLcl)
          
            setData(dataset)
           
        })
        .catch((err) => {
            setLoading(false)
        });
     }

     console.log(graphData,"123")


    return (
        <div className="mt-5 mb-3">
            <h5 className="heading border-0">{props?.name?.toUpperCase()} DETAILS</h5>
            <TabsComp defaultActiveKey="position" id="cash">
                <Tab eventKey="position" title="Position" className="custom-tab-content">
                    <Table>
                        <thead>
                            <tr>
                                <th rowSpan="2">Description</th>
                                <th rowSpan="2">Ccy</th>
                                <th rowSpan="2" className="br-bold">Quantity</th>
                                <th colSpan="2" className="redBg br-bold">In Account Ccy</th>
                                <th colSpan="2" className="yellowBg br-bold">In Valuation Ccy</th>
                                <th rowSpan="2">Unrealized Gain/Loss %</th>
                                <th rowSpan="2">% Total</th>
                                <th rowSpan="2"></th>
                            </tr>
                            <tr>
                                <th className="subTh">Avg Cost</th>
                                <th className="subTh br-bold">Market Price</th>
                                <th className="subTh">Market Value</th>
                                <th className="subTh br-bold">Unrealized Gain/Loss</th>
                            </tr>
                        </thead>
                        <tbody>
                            { 
                                data && data.rows ? data.rows.map((row,i)=>(
                                    <React.Fragment>
                                        <tr className="bg-gray" key={"row"+i}>
                                            <td colSpan="10">{row?.currency?.name}</td>
                                        </tr>
                                    
                                        {
                                            row?.rows.map((list,i)=>(
                                                <tr className="" key={"childrow"+i}>
                                                    <td>{list?.security?.name}</td>
                                                    <td>{row.currency.name}</td>
                                                    <td  className="text-right">{Helpers.formatNumberComma(list?.qty ?? 0)}</td>
                                                    <td  className="text-right">{Helpers.formatNumberComma(list?.avgCost)}</td>
                                                    <td  className="text-right">{Helpers.formatNumberComma(list?.marketPrice)}</td>
                                                    <td  className="text-right">{Helpers.amountFormat(list?.marketValue ?? 0)}</td>
                                                    <td  className="text-right"> {list?.unrealizedGainLoss ? Helpers.amountFormat(list?.unrealizedGainLoss ?? 0) : ""}</td>
                                                    <td  className="text-right">{list?.unrealizedGainLossPercentage ? Helpers.formatNumberComma(list?.unrealizedGainLossPercentage ?? 0)+"%" : ""}</td>
                                                    <td  className="text-right">{list?.totalPercentage ? Helpers.formatNumberComma(list.totalPercentage ?? 0)+"%" : ""}</td>
                                                    <td>
                                                         {(props.name == "CALL_OPTIONS" ||
                                                            props.name == "PUT_OPTIONS") ?
                                                             <Link to={"/transaction/options?type="+props.name+"&id="+list?.security?.id} state={{ payload: props.payload,id:list?.security?.id}}>{<i class="fa fa-bars"></i>}</Link>
                                                             :
                                                             <Link to={"/transaction/"+props.name+"?id="+list?.security?.id} state={{ payload: props.payload,id:list?.security?.id}}>{<i class="fa fa-bars"></i>}</Link>
                                                         }

                                                    </td>

                                                </tr>
                                            ))
                                        }
                                    </React.Fragment>
                                )) 
                                :
                                <tr>
                                    <td colspan="20" className="text-center">No data found</td>
                                </tr>
                            }
                            {data?.totalRow && <tr>
                                <td colSpan="10" className="emptyRow"></td>
                            </tr>}
                            {data?.totalRow && <tr>
                                <td colSpan="10" className="emptyRow"></td>
                            </tr>}
                        </tbody>
                        {data?.totalRow && <tfoot>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-right">{Helpers.amountFormat(data?.totalRow?.marketPrice ?? 0)}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-right">{data?.totalRow?.totalPercentage ? Helpers.formatNumberComma(data?.totalRow?.totalPercentage ?? 0)+"%" : ""}</td>
                                <td></td>
                            </tr>
                        </tfoot>}
                    </Table>
                </Tab>
                <Tab eventKey="charts" title="Charts"  className="custom-tab-content">
                    <div className="row">
                        <div className="col-md-6">
                                <GraphsCard title="EQUITY: CURRENCY ALLOCATION - MARKET VALUE %">
                                    <Pie data={marketValueByCurrency} />
                                </GraphsCard>
                        </div>
                        <div className="col-md-6">
                                <GraphsCard title="EQUITY: SECTOR ALLOCATION - MARKET VALUE - %">
                                    <Pie data={marketValueBySector} />
                                </GraphsCard>
                        </div>
                      </div>

                      <div className="col-md-12 mt-3">
                            <GraphsCard title="TOP 5 GAINERS & TOP 5 LOSERS">
                                <div className="row">
                                <div className="col-md-6">
                                        {top5Gainers && top5Gainers.topGainersCat && <Bar categories={top5Gainers?.topGainersCat} data={top5Gainers.topGainersVal} text="Unrealized Gain %" type="column"/>}
                                    </div>
                                    <div className="col-md-6">
                                        {top5Losers && top5Losers.topLoosersCat &&  <Bar categories={top5Losers?.topLoosersCat} data={top5Losers.topLoosersVal} text="Unrealized Loss %" type="column" colors={["#7a2d1b"]}/>}
                                    </div>
                                </div>
                            </GraphsCard>
                      </div>
                      
                </Tab>
            </TabsComp>
        </div>
    )
}

export default Equity
